var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activities fit20-font"},_vm._l((_vm.activities),function(item){return _c('Activity',{key:item.id,attrs:{"item":_vm.$t(item.name.toLowerCase()),"photo":_vm.photos[`${item.id}`],"score":item.score}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }